import { useState } from 'react';
import { UserCard } from '../types';
import { marketplace } from '../api';

interface ListModalProps {
  card: UserCard;
  onClose: () => void;
  onSuccess: () => void;
}

export default function ListModal({ card, onClose, onSuccess }: ListModalProps) {
  const [price, setPrice] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async () => {
    const priceTon = parseFloat(price);
    if (isNaN(priceTon) || priceTon <= 0) {
      setError('Enter a valid price in TON');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await marketplace.listCard(card.id, priceTon);
      onSuccess();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to list card');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-end z-50" onClick={onClose}>
      <div
        className="w-full bg-surface-card rounded-t-2xl p-5 space-y-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between">
          <h3 className="text-white font-bold text-lg">List for Sale</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white text-xl w-8 h-8 flex items-center justify-center">
            ✕
          </button>
        </div>

        <div className="flex items-center gap-3 p-3 bg-surface rounded-xl">
          <img src={card.image_url} alt={card.pokemon_name} className="w-12 h-16 object-cover rounded-lg" />
          <div>
            <p className="text-white font-semibold">{card.pokemon_name}</p>
            <p className="text-gray-400 text-sm">{card.set_name}</p>
            <p className="text-gray-500 text-xs">Market: ${card.market_price_usd.toFixed(2)}</p>
          </div>
        </div>

        <div>
          <label className="text-gray-400 text-sm block mb-1">Price (TON)</label>
          <div className="flex items-center gap-2 bg-surface rounded-xl px-3 py-2 border border-white/10">
            <span className="text-accent-gold font-bold">💎</span>
            <input
              type="number"
              step="0.01"
              min="0.01"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              placeholder="0.50"
              className="flex-1 bg-transparent text-white outline-none text-lg font-semibold"
            />
            <span className="text-gray-400 text-sm">TON</span>
          </div>
          <p className="text-gray-500 text-xs mt-1">3% platform fee on sale</p>
        </div>

        {error && <p className="text-red-400 text-sm">{error}</p>}

        <button
          onClick={handleSubmit}
          disabled={loading}
          className="w-full py-3 bg-accent-purple hover:bg-accent-purple/80 disabled:opacity-50 text-white font-semibold rounded-xl transition-colors"
        >
          {loading ? 'Listing…' : 'Confirm Listing'}
        </button>
      </div>
    </div>
  );
}
